
export interface TabViewModel 
{
    getTitle(): string;  
    deleteData(id: string): void;
    getTabView(): JSX.Element; 
}

export class TabViewModelImpl implements TabViewModel
{
    deleteData(id: string): void {
        throw new Error("Method not implemented.");
    }
    getTitle(): string 
    {
        throw new Error("Method not implemented.");
    }

    getTabView(): JSX.Element
    {
        throw new Error("Method not implemented");
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/tabs/tab/tabviewmodel.ts